/** @format */

import {safeDivide} from 'helpers/numberHelpers';

import {MetricKind, Period} from '../types';

interface Options {
  kind: MetricKind;
  planForPeriod: number;
  period: Period;
}

const MS_PER_DAY = 86_400_000;

// Делитель периода считаем по UTC-таймстампам, а не через date-fns differenceInDays:
// date-only ISO-строки парсятся как UTC-полночь, а differenceInDays меряет ЛОКАЛЬНЫЕ
// календарные дни — переход DST внутри периода занижал бы делитель на 1 (окт → 30 вместо 31,
// неделя через DST → 6 вместо 7). Разница UTC-полночей всегда кратна суткам.
export const getPlanForDate = ({kind, planForPeriod, period}: Options): number => {
  if (kind === 'ratio') {
    return planForPeriod;
  }

  const days = Math.round((Date.parse(period.end) - Date.parse(period.start)) / MS_PER_DAY) + 1;
  return safeDivide(planForPeriod, days);
};
